import React, { useState, useEffect } from 'react';
import './App.css';

// Placeholder imports for the components we'll create
import MapComponent from './components/Map/MapComponent';
import Dashboard from './components/Dashboard/Dashboard';
import Navigation from './components/Navigation/Navigation';
import StageProgress from './components/Stats/StageProgress';

function App() {
  const [loading, setLoading] = useState(true);
  const [error] = useState(null);

  useEffect(() => {
    // Initial data loading logic will go here
    // For now, simulate a loading state
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Harita ve Yarış Verileri Yükleniyor...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Bağlantı Hatası</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Yeniden Dene</button>
      </div>
    );
  }

  return (
    <div className="App">
      <Navigation />
      <div className="main-content">
        <div className="map-container">
          <MapComponent />
        </div>
        <div className="dashboard-container">
          <Dashboard />
        </div>
      </div>
      <div className="bottom-panel">
        <StageProgress />
      </div>
    </div>
  );
}

export default App;
